<div class="card" (click)="openImage(item.imageFile)" *ngIf="item && item.serviceComment" (click)="item.imageFile ? showImage(item.imageFile, item.serviceDescription, item.serviceComment) : ''">
  <div class="card--left">
    <svg class="shape one" viewBox="0 0 7 18" fill="none">
      <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#CC94B2" fill-opacity="0.25" />
    </svg>
    <svg class="shape two" viewBox="0 0 7 18" fill="none">
      <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#EEB8A5" fill-opacity="0.25" />
    </svg>
    <svg class="shape three" viewBox="0 0 7 18" fill="none">
      <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#D9D9D9" fill-opacity="0.25" />
    </svg>
    <svg class="shape four" viewBox="0 0 7 18" fill="none">
      <path d="M1.49994 0.5H3.99994C3.99994 0.5 2.25 4.5 3 9C3.75 13.5 6.99994 17.5 6.99994 17.5H4.49994C4.49994 17.5 1.49992 14 0.499945 10C-0.500033 6 1.49994 0.5 1.49994 0.5Z" fill="#D0CFD7" fill-opacity="0.25" />
    </svg>
    <svg class="shape five" viewBox="0 0 19 16" fill="none">
      <path d="M0.274837 7.03496C7.05256 7.79001 9 0 9 0C9 0 11.5 7.9 18.5 6.5C13.5 7.5 9 15.5 9 15.5C9 15.5 8.51083 8.16245 0.274837 7.03496C0.184093 7.02485 0.0924827 7.01321 0 7C0.0925576 7.01089 0.184167 7.02255 0.274837 7.03496Z" fill="#E4719A" fill-opacity="0.25" />
    </svg>

    @if (item.allowRefer) {
      <div class="card--left__price">{{ !item.referAmount || item.referAmount == "0" ? "FREE" : (item.isPercentage ? "" : "$") + item.referAmount + (item.isPercentage ? "%" : "") }} {{ item.useOffText ? "OFF" : "" }}</div>
    }
    <div class="card--left__comment">{{ item.serviceComment }}</div>
    <!-- @if (item.allowRefer) { @if (!profileInfo2?.linkReferedCount && !linkRfererUserId &&
        isLogin) {
        <button (click)="$event.stopPropagation(); showReferalUnlockExplaination()"
          class="my-button-3 below-btn"><i class="fa-solid fa-lock"></i> Unlock</button>
        } @else { @if (isLogin) {
        <button (click)="$event.stopPropagation(); claimMoreService(item)"
          class="my-button-3 below-btn">Claim</button>
        } @else {
        <button (click)="$event.stopPropagation(); loginHere()" class="my-button-3 below-btn"><i
            class="fa-solid fa-lock"></i> Login</button>
        } } } -->
  </div>

  <div class="card--right">
    <svg viewBox="0 0 53 190" fill="none">
      <path d="M51.9999 0L-4.95911e-05 0L-4.95911e-05 189.5L26 149C30 143.5 51.4646 112.825 37.9823 107C24.5 101.175 4.09374 108.545 5.5 92.5C6.90626 76.455 54.2432 19.6542 51.9999 0Z" fill="#fff" />
    </svg>

    <img class="card--right__image" [src]="imgUrl + item.imageFile" (error)="handleError($event)" />
    @if (item.iconText?.trim()) {
      <div style="position: absolute; top: 0; right: 0.5rem">
        <app-icon-selector [nowValue]="item.iconText" [icons]="[]" [selectionEnabled]="false"></app-icon-selector>
      </div>
    }
  </div>
</div>
